const lazyBlocks = [
  {
    selector: '.wp-block-o-recent-posts .recent-posts-swiper',
    importer: () => import('../../blocks/organisms/recent-posts/source.js'),
    initExport: 'initRecentPostsCarousel',
  },
  {
    selector: '.wp-block-o-card-carousel .card-carousel-swiper',
    importer: () => import('../../blocks/organisms/card-carousel/source.js'),
    initExport: 'initCardCarousel',
  },
  {
    selector: '.wp-block-o-tabs-carousel',
    importer: () => import('../../blocks/organisms/content-tabs/source.js'),
    initExport: 'initContentTabs',
  },
  {
    selector: '.toc',
    importer: () => import('../../blocks/molecules/toc/source.js'),
    initExport: 'initToc',
  },
  {
    selector: '.faq-source[data-faq-id]',
    importer: () => import('../../blocks/organisms/faqs/source.js'),
    initExport: 'initFAQMasonry',
  },
  {
    selector: '.filter-nav',
    importer: () => import('../../blocks/molecules/filter-nav/source.js'),
    initExport: 'initFilterNavs',
  },
];

async function loadBlockModule(block) {
  try {
    const module = await block.importer();

    if (typeof module[block.initExport] === 'function') {
      module[block.initExport]();
    }
  } catch (error) {
    console.error(`Failed to lazy-load block script for ${block.selector}`, error);
  }
}

function initLazyBlockScripts() {
  lazyBlocks.forEach((block) => {
    if (document.querySelector(block.selector)) {
      loadBlockModule(block);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLazyBlockScripts, { once: true });
} else {
  initLazyBlockScripts();
}
